const envKeys = {
    userInfoKey: process.env.REACT_APP_CT_USER_INFO_KEY,
    wmsApiUrl: process.env.REACT_APP_WMS_API_URL,
    ctApiUrl: process.env.REACT_APP_CT_API_URL,
    oAuthUrl: process.env.REACT_APP_OAUTH_URL,
};
Object.freeze(envKeys);
export default envKeys;
